import * as actions from './labelActions';

const initialState = {
  // Data
  brands: [],
  sizes: [],
  selectedSize: null,
  batchLabelData: null,
  spawnSourceLabelData: null,
  fieldsConfig: null,
  categories: [],

  // Loading states
  loading: false,
  loadingBatchData: false,
  loadingSpawnSourceData: false,

  // Status
  error: null,
  success: null,
};

export default function labelReducer(state = initialState, action) {
  switch (action.type) {
    // GET LABEL BRANDS
    case actions.GET_LABEL_BRANDS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_LABEL_BRANDS.SUCCESS:
      return {
        ...state,
        loading: false,
        brands: action.payload.data,
      };
    case actions.GET_LABEL_BRANDS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET LABEL SIZES
    case actions.GET_LABEL_SIZES.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_LABEL_SIZES.SUCCESS:
      return {
        ...state,
        loading: false,
        sizes: action.payload.data,
      };
    case actions.GET_LABEL_SIZES.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET LABEL SIZE (single)
    case actions.GET_LABEL_SIZE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_LABEL_SIZE.SUCCESS:
      return {
        ...state,
        loading: false,
        selectedSize: action.payload.data,
      };
    case actions.GET_LABEL_SIZE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // CREATE LABEL SIZE
    case actions.CREATE_LABEL_SIZE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.CREATE_LABEL_SIZE.SUCCESS:
      return {
        ...state,
        loading: false,
        sizes: [action.payload.data, ...state.sizes],
        success: 'Custom label size created successfully',
      };
    case actions.CREATE_LABEL_SIZE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET BATCH LABEL DATA
    case actions.GET_BATCH_LABEL_DATA.REQUEST:
      return {
        ...state,
        loadingBatchData: true,
        error: null,
      };
    case actions.GET_BATCH_LABEL_DATA.SUCCESS:
      return {
        ...state,
        loadingBatchData: false,
        batchLabelData: action.payload.data,
      };
    case actions.GET_BATCH_LABEL_DATA.FAILURE:
      return {
        ...state,
        loadingBatchData: false,
        error: action.payload,
      };

    // GET SPAWN SOURCE LABEL DATA
    case actions.GET_SPAWN_SOURCE_LABEL_DATA.REQUEST:
      return {
        ...state,
        loadingSpawnSourceData: true,
        error: null,
      };
    case actions.GET_SPAWN_SOURCE_LABEL_DATA.SUCCESS:
      return {
        ...state,
        loadingSpawnSourceData: false,
        spawnSourceLabelData: action.payload.data,
      };
    case actions.GET_SPAWN_SOURCE_LABEL_DATA.FAILURE:
      return {
        ...state,
        loadingSpawnSourceData: false,
        error: action.payload,
      };

    // GET LABEL FIELDS CONFIG
    case actions.GET_LABEL_FIELDS_CONFIG.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_LABEL_FIELDS_CONFIG.SUCCESS:
      return {
        ...state,
        loading: false,
        fieldsConfig: action.payload.data,
      };
    case actions.GET_LABEL_FIELDS_CONFIG.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET LABEL CATEGORIES
    case actions.GET_LABEL_CATEGORIES.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_LABEL_CATEGORIES.SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload.data,
      };
    case actions.GET_LABEL_CATEGORIES.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // UI STATE
    case actions.SET_SELECTED_LABEL_SIZE:
      return {
        ...state,
        selectedSize: action.payload,
      };

    case actions.CLEAR_LABEL_DATA:
      return {
        ...state,
        batchLabelData: null,
        spawnSourceLabelData: null,
      };

    case actions.RESET_LABELS_STATE:
      return initialState;

    default:
      return state;
  }
}
